export const SHELLY_DIMMER_2 = 'shellydimmer2';
